import { Controller } from "@hotwired/stimulus"

/**
 * cta-track — names a register CTA click for PostHog.
 *
 * Autocapture already records the raw click; this emits the named event the
 * signup funnel is built on, so a registration can be traced back to the
 * page and placement that produced it. The placement vocabulary is the same
 * one the demo button posts as `cta_source` (`landing-hero`, `ai-tools-hero`,
 * `cta-band`), so demo starts and registrations from one placement compare
 * directly. The link navigates as normal; posthog-js flushes on pagehide.
 *
 * Usage, on the link itself:
 *   <a href="/auth/register" data-controller="cta-track"
 *      data-cta-track-source-value="ai-tools-hero"
 *      data-action="click->cta-track#capture">
 */
const EV_REGISTER_CTA_CLICKED = "register_cta_clicked"

export default class extends Controller {
  static values = { source: String }

  capture() {
    if (typeof window.posthog === "undefined") return
    window.posthog.capture(EV_REGISTER_CTA_CLICKED, {
      cta_source: this.sourceValue,
      path: window.location.pathname,
    })
  }
}
